export default {
  SET_COMMON_SERVICES (state, data) {
    state.commonServices = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/commonServices.js